<div class="modal">
    <div class="modal-content">
        <h2>Login</h2>
        <form (ngSubmit)="submit()" #form="ngForm">
            <label for="username">Username*</label>
            <input type="text"
                   [(ngModel)]="username"
                   name="username"
                    #usernameRef="ngModel"
                   placeholder="DOMAIN\\username"
                   required 
                   [ngClass]="{'invalid': submitted && usernameRef.invalid}"/>
            <div class="error" *ngIf="submitted && usernameRef.invalid">
                Username is required
            </div>
            <label for="password">Password*</label>
            <input type="password"
                   [(ngModel)]="password"
                   name="password"
                    #passwordRef="ngModel"
                   placeholder="Password"
                   required [ngClass]="{'invalid': submitted && passwordRef.invalid}" />
              <div class="error" *ngIf="submitted && passwordRef.invalid">
                Password is required
              </div>

            <div class="button-row">
                <button type="submit">Login</button>
                <button type="button" class="cancel" (click)="onCancel.emit()">Cancel</button>
            </div>
        </form>
    </div>
</div>
